module.exports = __webpack_public_path__ + "static/media/current-documentation_top.ca48f54c.jpg";